const config = {
    delegatedAllowedAssetNames: ['solana', 'usdcoin_solana'],
};
export default config;
